import { useEffect, useState } from 'react'

export type useBranchSmsStatus =
  | 'loading'
  | 'ready'
  | 'sending'
  | 'success'
  | 'error'

type LinkData = {
  tags?: string[]
  feature: string
  channel?: string
  campaign?: string
  data: {
    $deeplink_path?: string
    $custom_sms_text?: string
    mydata?: string
    $desktop_url?: string
    $ios_url?: string
    $ipad_url?: string
    $android_url?: string
    $og_app_id?: string
    $og_title?: string
    $og_description?: string
    $og_image_url?: string
    [key: string]: any
  }
}

export type branchSendSms = (
  phone: string,
  linkData: LinkData,
  options: {
    [key: string]: any
    onError?: (error: string) => void
    onSuccess?: () => void
  },
  callback: (error: Error) => void
) => void

export type hookSendSms = (
  phone: string,
  linkData: LinkData,
  options: {
    [key: string]: any
  }
) => void

declare global {
  interface Window {
    branch: {
      sendSMS: branchSendSms
    }
  }
}

window.branch = window.branch || {}

const sdkScript = `
  // load Branch
  (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);
  // init Branch
  branch.init('${process.env.REACT_APP_BRANCH_KEY}');
`

const BRANCH_SDK_ID = 'branch-sdk'

const useBranchSms = () => {
  const [status, setStatus] = useState<useBranchSmsStatus>('loading')
  const [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    const branchScript = document.getElementById(BRANCH_SDK_ID)
    if (!branchScript) {
      const script = document.createElement('script')
      script.id = BRANCH_SDK_ID
      script.innerHTML = sdkScript
      document.head.appendChild(script)
      // TODO: use the branch.init callback to detect when Branch is actually ready
      setStatus('ready')

      // Cleanup: removes the Branch script, if present
      return function cleanup() {
        const branch = document.getElementById(BRANCH_SDK_ID)
        branch?.parentNode?.removeChild(branch)
      }
    } else {
      setStatus('ready')
    }
  }, [])

  const sendSMS: hookSendSms = (phone, linkData, options) => {
    setStatus('sending')
    setErrorMessage('')
    window.branch.sendSMS(phone, linkData, options, error => {
      if (error) {
        setStatus('error')
        setErrorMessage(error.message)
        if (options.onError) options.onError(error.message)
      } else {
        setStatus('success')
        if (options.onSuccess) options.onSuccess()
      }
    })
  }

  return {
    status,
    errorMessage,
    sendSMS,
  }
}

export default useBranchSms
